<div *ngIf="show" class="recent-winner-banner" data-testid="recent-winner-banner">
  <strong>Recent Winner Alert:</strong>
  This player last won on {{ lastWinDate | date:'mediumDate' }}
  <span *ngIf="contactLockDaysRemaining > 0"> - Contact info locked for {{ contactLockDaysRemaining }} more {{ contactLockDaysRemaining === 1 ? 'day' : 'days' }}</span>
</div>
